import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { assessmentConfigsGetAction } from '../../../redux/action/gameConfig';
import AssessmentConfigCreateModal from '../../common/Modal/GameConfigModal/AssessmentCreateModal';
import TableHeader from '../../common/table/TableHeader';
import AssessmentFilter from './AssessmentFilters';
import AssessmentTable from './AssessmentTable';
import { useSearchParams } from 'react-router-dom';

const AssessmentContent = () => {
  const [filterValue, setFilterValue] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize1, setPageSize] = useState(1);
  const [isModal, setIsModal] = useState(false);
  const [isFilter, setFilter] = useState(false);

  const [searchParam] = useSearchParams();

  const dispatch = useDispatch();

  const { assessmentConfigs } = useSelector(state => state.gameConfig);

  const onToggleModal = () => {
    setIsModal(!isModal);
  };
  const onToggleFilter = () => {
    setFilter(!isFilter);
  };

  const fetchData = useCallback(
    ({ pageSize, pageIndex }) => {
      dispatch(assessmentConfigsGetAction(filterValue, pageIndex, pageSize));
      setPageSize(pageSize);
    },
    [filterValue]
  );

  useEffect(() => {
    if (assessmentConfigs)
      setPageCount(Math.ceil(assessmentConfigs?.total_items / pageSize1));
  }, [assessmentConfigs, pageSize1]);

  useEffect(() => {
    const filter = Object.fromEntries([...searchParam]);
    setFilterValue(filter);
  }, [searchParam]);
  return (
    <div>
      <TableHeader
        FileName={'Assessment'}
        modalOpenfunc={onToggleModal}
        addButtonEnable={true}
        onToggleFilter={onToggleFilter}
      />
      <div
        className={`absolute w-[23rem] mt-2 p-2 bg-slate-400 rounded-md right-0 z-10 ${
          isFilter ? 'block' : 'hidden'
        }`}
      >
        <AssessmentFilter onToggleFilter={onToggleFilter} />
      </div>
      <AssessmentTable fetchData={fetchData} pageCount={pageCount} />
      {isModal && (
        <AssessmentConfigCreateModal
          isModalOpen={isModal}
          onToggleModal={onToggleModal}
        />
      )}
    </div>
  );
};

export default AssessmentContent;
